export default __webpack_public_path__ + "static/i-wp-57b9a431ccfc14ec875d19d25b8cbf54.png";